import axiosInstance from './axios';
import { SitesParams, SitesResponse } from 'types/site';
import { WheelSettingsResponse, SpinConfigResponse } from 'types/wheel';

export const siteService = {
  getSites: async (params: SitesParams): Promise<SitesResponse> => {
    const { page, limit, sortField, sortValue } = params;
    const response = await axiosInstance.get(`/admin/sites`, {
      params: {
        page,
        limit,
        sortField,
        sortValue,
      },
    });
    return response.data;
  },
  updateSiteSettings: async (siteId: string | number, data: any): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/sites/${siteId}/settings`, data);
    return response.data;
  },
  getWheelSettings: async (siteId: string | number): Promise<WheelSettingsResponse> => {
    const response = await axiosInstance.get(`/admin/wheel`, {
      params: { siteId },
    });
    return response.data;
  },
  updateWheelPrizes: async (data: {
    siteId: number;
    levelKey: string;
    prizes: any[];
  }): Promise<any> => {
    const response = await axiosInstance.put(`/admin/wheel/prizes`, data);
    return response.data;
  },
  toggleWheelStatus: async (data: {
    siteId: number;
    levelKey: string;
    isEnabled: boolean;
  }): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/wheel`, data);
    return response.data;
  },
  getSpinConfig: async (siteId: string | number): Promise<SpinConfigResponse> => {
    const response = await axiosInstance.get(`/admin/wheel/spin-config`, {
      params: { siteId },
    });
    return response.data;
  },
  updateSpinConfig: async (data: {
    siteId: number;
    tier: string;
    dailySpinLimit: number;
    maxWinPerSpin: string;
  }): Promise<any> => {
    const response = await axiosInstance.put(`/admin/wheel/spin-config`, data);
    return response.data;
  },
  getPointCategories: async (siteId: string | number): Promise<any> => {
    const response = await axiosInstance.get(`/admin/point-categories`, {
      params: { siteId },
    });
    return response.data;
  },
  getPointSubCategories: async (categoryId: string | number): Promise<any> => {
    const response = await axiosInstance.get(`/admin/point-categories/${categoryId}`);
    return response.data;
  },
  updatePointCategory: async (
    id: string | number,
    data: { name: string; multiplier: string | number },
  ): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/point-categories/${id}`, data);
    return response.data;
  },
  updatePointSubCategory: async (
    id: string | number,
    data: { name: string; multiplier: string | number; isActive: boolean },
  ): Promise<any> => {
    const response = await axiosInstance.patch(
      `/admin/point-categories/sub-categories/${id}`,
      data,
    );
    return response.data;
  },
  createPointCategory: async (data: {
    siteId: string | number;
    key: string;
    name: string;
    multiplier: string | number;
  }): Promise<any> => {
    const response = await axiosInstance.post(`/admin/point-categories`, data);
    return response.data;
  },
  deletePointCategory: async (id: string | number): Promise<any> => {
    const response = await axiosInstance.delete(`/admin/point-categories/${id}`);
    return response.data;
  },
  createPointSubCategory: async (data: {
    categoryId: number;
    key: string;
    name: string;
    multiplier: string | number;
    isActive: boolean;
  }): Promise<any> => {
    const response = await axiosInstance.post(`/admin/point-categories/sub-categories`, data);
    return response.data;
  },
  deletePointSubCategory: async (id: string | number): Promise<any> => {
    const response = await axiosInstance.delete(`/admin/point-categories/sub-categories/${id}`);
    return response.data;
  },
  getLevelSettings: async (siteId: string | number): Promise<any> => {
    const response = await axiosInstance.get(`/admin/wheel/level-settings`, {
      params: { siteId },
    });
    return response.data;
  },
  updateLevelSettings: async (data: {
    siteId: number;
    levelKey: string;
    spinsOnLevelUp: number;
    minPoints: number;
  }): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/wheel/level-settings`, data);
    return response.data;
  },
  updateTierName: async (data: {
    siteId: number;
    tier: string;
    displayName: string;
    slug: string;
  }): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/wheel/tier-names`, data);
    return response.data;
  },
  getRestrictedCountries: async (siteId: string | number): Promise<any> => {
    const response = await axiosInstance.get(`/admin/restricted-countries`, {
      params: { siteId },
    });
    return response.data;
  },
  toggleRestrictedCountry: async (id: string | number): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/restricted-countries/${id}/toggle`);
    return response.data;
  },
};

export { siteLanguagesService } from './siteLanguages';
